import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SiteContentService, SiteSettings } from '../../services/site-content.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
})
export class FooterComponent implements OnInit {
  public firstItems;
  public secondItems;
  public thirdItems;
  public fourthItems;
  public fifthItems;
  public sixthItems;
  isMobile: boolean;
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  mobileWidth: number = 760;
  public innerWidth: any;
  public url = environment.url;
  public settings: SiteSettings = { id: 'global' };
  public accessibilityUrl = 'https://cfasante.fr/assets-upload/ACCESSIBILITÉ.pdf';
  public qualiopiCertificateUrl = environment.url + 'assets-upload/Certificat Qualiopi.pdf';
  public mapUrl: SafeResourceUrl;
  constructor(
    private router: Router,
    private siteContentService: SiteContentService,
    private sanitizer: DomSanitizer
  ) {
    this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3860.4868126420292!2d-61.081807324770395!3d14.628285476397998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8c6aa7006d93cd9d%3A0xb5f4b40f63f0c18b!2sCfa%20Health!5e0!3m2!1sen!2sfr!4v1717062473360!5m2!1sen!2sfr'
    );
  }

  // Detect screen size for default style of footer
  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.siteContentService.getSettings().subscribe({
      next: (settings) => {
        if (settings) {
          this.settings = settings;
          if (settings.map_url) {
            this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(settings.map_url);
          }
        }
      },
      error: () => undefined,
    });
    this.siteContentService.getDocuments().subscribe({
      next: (documents) => {
        this.accessibilityUrl = this.siteContentService.resolveDocumentUrl(
          documents.find((document) => document.resource_key === 'accessibilite'),
          this.accessibilityUrl
        );
        this.qualiopiCertificateUrl = this.siteContentService.resolveDocumentUrl(
          documents.find((document) => document.resource_key === 'certificat-qualiopi'),
          this.qualiopiCertificateUrl
        );
      },
      error: () => undefined,
    });
    this.isMobile = this.width < this.mobileWidth;
    if (this.innerWidth <= this.mobileWidth) {
      
      this.firstItems = false;
      this.secondItems = false;
      this.thirdItems = false;
      this.fourthItems = false;
      this.fifthItems = false;
      this.sixthItems = false;
    } else {
      this.firstItems = true;
      this.secondItems = true;
      this.thirdItems = true;
      this.fourthItems = true;
      this.fifthItems = true;
      this.sixthItems = true;
    }
  }

  // Detect screen size change for style of footer
  ngDoCheck(event): void {
    this.isMobile = this.width < this.mobileWidth;
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.height = event.target.innerHeight;
    this.isMobile = this.width < this.mobileWidth;
    if (this.isMobile) {
      this.firstItems = true;
      this.secondItems = true;
      this.thirdItems = true;
      this.fourthItems = true;
      this.fifthItems = true;
      this.sixthItems = true;
    }
  }

  showFirstItems() {
    this.firstItems = !this.firstItems;
  }
  showSecondItems() {
    this.secondItems = !this.secondItems;
  }
  showThirdItems() {
    this.thirdItems = !this.thirdItems;
  }
  showFourthItems() {
    this.fourthItems = !this.fourthItems;
  }
  showFifthItems() {
    this.fifthItems = !this.fifthItems;
  }
  showSixthItems() {
    this.sixthItems = !this.sixthItems;
  }

  goToHome() {
    this.router.navigateByUrl('accueil');
  }

  goToContact() {
    this.router.navigateByUrl('contact');
  }

  goToInscription() {
    this.router.navigateByUrl('inscription');
  }

  goToAbout() {
    this.router.navigateByUrl('a-propos');
  }

  goToApprentice() {
    this.router.navigateByUrl('apprenti');
  }

  goToEmployer() {
    this.router.navigateByUrl('employeur');
  }

  goToUfa() {
    this.router.navigateByUrl('ufa');
  }
}
